module.exports = __webpack_public_path__ + "static/media/feather-texture.3a8b85ab.bmp";